import { ResponsiveLine } from "@nivo/line";
import type { PricePoint } from "../../../models/PricePoint";
import { priceString } from "../../../utils/string";
import { Table, TableBody, TableCell, TableRow } from "../../../design/table";

interface Props {
  pricePoints: PricePoint[];
}

const PricePointChart: React.FC<Props> = ({ pricePoints }) => {
  const last3PricePoints = pricePoints.slice(-3);
  return (
    <>
      <div className="h-[400px] w-full bg-white p-4 shadow-md rounded-lg">
        <ResponsiveLine
          data={[
            {
              id: "Potential Value",
              data: pricePoints.map((item) => ({
                x: `${item.id}`, // Format date as 'YYYY-MM'
                y: item.price,
              })),
            },
          ]}
          margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
          xScale={{ type: "point" }}
          yScale={{
            type: "linear",
            min: "auto",
            max: "auto",
            stacked: true,
            reverse: false,
          }}
          axisLeft={{
            format: (value: number) => formatYAxis(value / 100),
          }}
          axisTop={null}
          axisRight={null}
          colors={{ scheme: "nivo" }}
          pointSize={10}
          pointColor={{ theme: "background" }}
          pointBorderWidth={2}
          pointBorderColor={{ from: "serieColor" }}
          pointLabelYOffset={-12}
          useMesh={true}
          tooltip={({ point }) => (
            <div className="px-3 py-1 text-xs text-white bg-black rounded shadow-md">
              <strong>{point.data.xFormatted}</strong>:{" "}
              {priceString(Number(point.data.yFormatted || "0") / 100)}
            </div>
          )}
          legends={[
            {
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 100,
              translateY: 0,
              itemsSpacing: 0,
              itemDirection: "left-to-right",
              itemWidth: 80,
              itemHeight: 20,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: "circle",
              symbolBorderColor: "rgba(0, 0, 0, .5)",
              effects: [
                {
                  on: "hover",
                  style: {
                    itemBackground: "red",
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
        />
      </div>
      <Table>
        <TableBody>
          <TableRow>
            {last3PricePoints.map((pricePoint, index) => (
              <TableCell
                key={index}
                className="text-sm font-medium text-center"
              >
                {pricePoint.id}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            {last3PricePoints.map((pricePoint, index) => (
              <TableCell key={index} className="text-sm text-center">
                {priceString(pricePoint.price / 100)}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};
const formatYAxis = (value: number) => {
  if (value >= 1000000000) {
    return `${(value / 1000000000).toFixed(1)}B`;
  } else if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`;
  } else if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}K`;
  }
  return value.toString();
};
export default PricePointChart;
